import Image from 'next/image';

import { Box, Flex, Heading, SimpleGrid, Text } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';
import {
  AccreditationColorScheme,
  accreditationGradients,
  AccreditationTopBarItem,
} from '~/features/accreditation/types';

export function AccreditationTopBar({
  colorScheme = 'blue',
  items,
}: {
  colorScheme?: AccreditationColorScheme;
  items: AccreditationTopBarItem[];
}) {
  const gradients = accreditationGradients[colorScheme];
  return (
    <ContentContainer
      as='section'
      display='flex'
      flexDirection='column'
      gap='16px'
      mdPadding='0'
      mobilePadding='0'
      overflow={{ base: 'hidden', lg: 'visible' }}
    >
      <Box position='relative' width='100%'>
        <Flex
          alignItems={{ base: 'flex-start', lg: 'center' }}
          bgGradient={{ base: gradients.topBarBg.base, lg: gradients.topBarBg.lg }}
          borderBottomRadius={{ base: '0px', lg: '12px' }}
          flexDirection={{ base: 'column', lg: 'row' }}
          gap={{ base: '24px', lg: '16px' }}
          justifyContent='space-between'
          position='relative'
          width='100%'
          zIndex={2}
          padding={{
            base: '32px 148px 32px 32px',
            lg: '56px 48px',
          }}
        >
          <Box display={{ base: 'none', lg: 'block' }} inset={0} position='absolute'>
            <Image
              alt=''
              quality={100}
              sizes='1242px'
              src='/images/accreditation/top-bar-bg.png'
              style={{
                objectFit: 'cover',
                objectPosition: 'center',
                pointerEvents: 'none',
              }}
              fill
            />
          </Box>
          <Box display={{ base: 'block', lg: 'none' }} pointerEvents='none' position='absolute' right={0} top={0}>
            <Image
              alt='Accreditation Badge'
              height={280}
              quality={100}
              src='/images/accreditation/woolf-badge-mobile.png'
              width={280}
              priority
            />
          </Box>
          <Box
            display={{ base: 'none', lg: 'block' }}
            left='calc(50%)'
            pointerEvents='none'
            position='absolute'
            top='-130px'
            transform='translateX(-50%) scale(0.8)'
          >
            <Image
              alt='Accreditation Badge'
              height={466}
              quality={100}
              src='/images/accreditation/woolf-badge.png'
              width={375}
              style={{
                pointerEvents: 'none',
                objectPosition: '88px center',
              }}
              priority
            />
          </Box>
          <SimpleGrid columns={[1, 1, 2, 4]} gap={{ base: '24px', lg: '16px' }} position='relative' width='100%'>
            {items.map((item) => (
              <Flex key={item.id} alignItems={{ base: 'flex-start', lg: 'center' }} direction='column' gap='12px'>
                {item.icon}
                <Flex
                  alignItems={{ base: 'flex-start', lg: 'center' }}
                  direction='column'
                  gap={{ base: '0px', lg: '4px' }}
                >
                  <Heading as='p' color='white' size={{ base: 'heading-10', lg: 'heading-8' }}>
                    {item.title}
                  </Heading>
                  <Text
                    color='grey.300'
                    fontSize='sm'
                    textAlign={{
                      base: 'start',
                      lg: 'center',
                    }}
                  >
                    {item.description}
                  </Text>
                </Flex>
              </Flex>
            ))}
          </SimpleGrid>
        </Flex>
      </Box>
      <Text color='grey.500' fontSize='sm' m='auto' px='16px'>
        * Cancel anytime. Estimated cost for full program when working 27 hrs/week. No commitment required to complete
        the program.
      </Text>
    </ContentContainer>
  );
}
